var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3910_1294)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3910_1294",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0H0.5V20H20.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3910_1294)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0C18.735 0 20.5 1.48151 20.5 8.88892C20.5 13.7037 19.6668 16.6667 15.9168 16.6667C13.9128 16.6667 13.3167 17.6187 12.7617 18.5051C12.278 19.2774 11.8255 20 10.5002 20C9.175 20 8.72249 19.2774 8.23886 18.5051C7.68373 17.6187 7.08758 16.6667 5.08353 16.6667C1.33353 16.6667 0.5 13.6089 0.5 8.88892C0.5 1.56889 2.265 0 10.5 0ZM18.8333 8.88892C18.8333 5.14 18.3358 3.66593 17.4861 2.91696C17.0535 2.53566 16.3786 2.20644 15.2217 1.98388C14.0565 1.75969 12.5288 1.66667 10.5 1.66667C8.47466 1.66667 6.94902 1.7649 5.78637 1.99458C4.63269 2.22248 3.95517 2.55755 3.51915 2.94512C2.66166 3.70734 2.16667 5.19102 2.16667 8.88892C2.16667 11.2312 2.38839 12.8267 2.87627 13.8025C3.09847 14.247 3.35288 14.5134 3.63781 14.683C3.92947 14.8566 4.37353 15 5.08353 15C6.2813 15 7.25453 15.2711 8.04651 15.8077C8.80853 16.324 9.25333 16.9923 9.53733 17.4393L9.6515 17.6193C9.89708 18.007 9.97842 18.1354 10.0935 18.2387L10.098 18.243C10.1222 18.2666 10.1905 18.3333 10.5002 18.3333C10.81 18.3333 10.8783 18.2666 10.9025 18.243L10.907 18.2387C11.0221 18.1354 11.1034 18.0071 11.349 17.6192L11.4631 17.4394C11.7471 16.9925 12.1919 16.3241 12.9539 15.8077C13.7458 15.2711 14.7191 15 15.9168 15C16.6357 15 17.0836 14.8589 17.3755 14.6887C17.658 14.524 17.9078 14.2666 18.1265 13.8329C18.6104 12.8733 18.8333 11.284 18.8333 8.88892Z",
    fill: "#15194B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 5.83398C9.29358 5.83398 9.66667 6.20707 9.66667 6.66731C9.66667 7.12755 9.29358 7.50064 8.83333 7.50064H6.33333C5.87309 7.50064 5.5 7.12755 5.5 6.66731C5.5 6.20707 5.87309 5.83398 6.33333 5.83398H8.83333Z",
    fill: "#15194B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.16602C15.1269 9.16602 15.5 9.53911 15.5 9.99936C15.5 10.4596 15.1269 10.8327 14.6667 10.8327H6.33333C5.87309 10.8327 5.5 10.4596 5.5 9.99936C5.5 9.53911 5.87309 9.16602 6.33333 9.16602H14.6667Z",
    fill: "#15194B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3910_1294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.c980419b2b6e28bd95a11e2a0827fc87.svg";
export { ForwardRef as ReactComponent };